export const PROJECTILE_CONFIGS = {
    ap_100mm: {
        id: 'ap_100mm',
        name: '100mm BR-412D APHEBC',
        projectileType: 'AP',
        massKg: 15.8,
        caliberMm: 100,
        muzzleVelocityMs: 887,
        dragCoefficient: 0.28,
        referenceAreaM2: 0.00785,
        nominalPenetrationMm: 235,
        ricochetAngleDeg: 70,
        normalizationAngleDeg: 4.0,
        fuzeSensitivityMm: 14,
        explosiveMassKg: 0.065,
        maxRangeM: 3500,
        dispersionRad: 0.0012,
    },
    apfsds_125mm: {
        id: 'apfsds_125mm',
        name: '125mm 3BM42 Mango APFSDS',
        projectileType: 'APFSDS',
        massKg: 4.85,
        caliberMm: 125, // sub-caliber rod ~32mm
        muzzleVelocityMs: 1700,
        dragCoefficient: 0.18,
        referenceAreaM2: 0.0008,
        nominalPenetrationMm: 460,
        ricochetAngleDeg: 78,
        normalizationAngleDeg: 2.0,
        maxRangeM: 4000,
        dispersionRad: 0.0006,
    },
    heat_125mm: {
        id: 'heat_125mm',
        name: '125mm 3BK18M Shaped Charge (HEAT-FS)',
        projectileType: 'HEAT',
        massKg: 19.0,
        caliberMm: 125,
        muzzleVelocityMs: 905,
        dragCoefficient: 0.32,
        referenceAreaM2: 0.0122,
        nominalPenetrationMm: 550,
        ricochetAngleDeg: 82,
        normalizationAngleDeg: 0.0,
        fuzeSensitivityMm: 5,
        explosiveMassKg: 1.76,
        maxRangeM: 3000,
        dispersionRad: 0.0014,
    },
    he_125mm: {
        id: 'he_125mm',
        name: '125mm 3OF26 High Explosive Fragmentation (HE-FRAG)',
        projectileType: 'HE',
        massKg: 23.0,
        caliberMm: 125,
        muzzleVelocityMs: 850,
        dragCoefficient: 0.35,
        referenceAreaM2: 0.0122,
        nominalPenetrationMm: 45,
        ricochetAngleDeg: 85,
        normalizationAngleDeg: 0.0,
        fuzeSensitivityMm: 2,
        explosiveMassKg: 3.4,
        maxRangeM: 3500,
        dispersionRad: 0.0018,
    },
    training_100mm: {
        id: 'training_100mm',
        name: '100mm TP-T Target Practice Tracer',
        projectileType: 'TRAINING',
        massKg: 10.0,
        caliberMm: 100,
        muzzleVelocityMs: 900,
        dragCoefficient: 0.3,
        referenceAreaM2: 0.00785,
        nominalPenetrationMm: 80,
        ricochetAngleDeg: 70,
        normalizationAngleDeg: 1.0,
        maxRangeM: 2000,
        dispersionRad: 0.002,
    },
};
export const AMMUNITION_CATALOG = {
    ...PROJECTILE_CONFIGS,
    ap_3bm42: PROJECTILE_CONFIGS.apfsds_125mm,
    apfsds_dm33: PROJECTILE_CONFIGS.apfsds_125mm,
    heat_3bk18m: PROJECTILE_CONFIGS.heat_125mm,
    he_3of26: PROJECTILE_CONFIGS.he_125mm,
    tp_m831a1: PROJECTILE_CONFIGS.training_100mm,
};
export function getProjectileConfig(id) {
    const proj = AMMUNITION_CATALOG[id] || PROJECTILE_CONFIGS[id];
    if (!proj) {
        return PROJECTILE_CONFIGS.apfsds_125mm;
    }
    return proj;
}
/**
 * Computes kinetic energy in Joules: E = 0.5 * m * v^2
 */
export function calculateKineticEnergy(massKg, velocityMs) {
    return 0.5 * massKg * velocityMs * velocityMs;
}
/**
 * Computes deterministic aerodynamic velocity drop over distance using air drag equation.
 * dt-stable ballistic step.
 */
export function computeVelocityAtDistance(muzzleVelocityMs, massKg, dragCoefficient, referenceAreaM2, distanceM, airDensityKgM3 = 1.225) {
    if (distanceM <= 0)
        return muzzleVelocityMs;
    // Numerical step integration (step = 10m)
    let v = muzzleVelocityMs;
    const step = 10;
    const steps = Math.floor(distanceM / step);
    for (let i = 0; i < steps; i++) {
        const dragForce = 0.5 * airDensityKgM3 * v * v * dragCoefficient * referenceAreaM2;
        const decel = dragForce / massKg;
        const dt = step / Math.max(v, 1);
        v = Math.max(0, v - decel * dt);
        if (v <= 0)
            break;
    }
    return Math.round(v * 10) / 10;
}
//# sourceMappingURL=projectiles.js.map